import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ClipboardCheck } from "lucide-react";

const TONE = { SESUAI: "bg-emerald-50 text-emerald-700", "NEED OWNER CONFIRMATION": "bg-amber-50 text-amber-700", "PERLU KOREKSI": "bg-red-50 text-red-700", CEK: "bg-blue-50 text-blue-700" };

export const UserAudit = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!open || data) return;
    api.get("/master-users/audit").then((r) => setData(r.data)).catch((e) => setErr(e.response?.data?.detail || "Gagal memuat audit"));
  }, [open, data]);
  return (
    <div className="mt-3 rounded-lg border border-gray-100 bg-white p-3 shadow-sm" data-testid="user-audit-panel">
      <Button data-testid="user-audit-toggle" size="sm" variant="outline" onClick={() => setOpen((o) => !o)}><ClipboardCheck size={14} className="mr-1" />{open ? "Tutup Audit User" : "Audit User (Owner)"}</Button>
      {open && err && <p data-testid="user-audit-error" className="mt-2 text-xs text-red-600">{err}</p>}
      {open && data && (
        <div className="mt-3 overflow-x-auto">
          <table className="w-full text-left text-[11px]">
            <thead className="text-gray-500"><tr>{["Karyawan", "Username", "Divisi", "Role Saat Ini", "Role Benar", "Login", "Status", "Catatan"].map((h) => <th key={h} className="px-2 py-1 font-semibold">{h}</th>)}</tr></thead>
            <tbody>
              {data.rows.map((r) => (
                <tr key={r.id} data-testid={`audit-row-${r.id}`} className="border-t border-gray-100">
                  <td className="px-2 py-1 font-semibold text-gray-800">{r.employee_name}{r.employee_id ? ` (${r.employee_id})` : ""}<div className="font-normal text-gray-400">{r.employee_position}</div></td>
                  <td className="px-2 py-1">{r.username}</td>
                  <td className="px-2 py-1">{r.division}</td>
                  <td className="px-2 py-1">{r.existing_role || "—"}</td>
                  <td className="px-2 py-1 font-semibold">{r.correct_role || "—"}</td>
                  <td className="px-2 py-1">{r.login_status}</td>
                  <td className="px-2 py-1"><span className={`rounded-full px-2 py-0.5 font-semibold ${TONE[r.status] || ""}`}>{r.status}</span></td>
                  <td className="px-2 py-1 text-gray-500">{r.notes.join(", ") || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.employees_without_account.length > 0 && (
            <p data-testid="audit-no-account" className="mt-2 text-[11px] text-gray-500">Karyawan aktif tanpa akun: {data.employees_without_account.map((e) => `${e.employee_name} (${e.employee_id})`).join(", ")}</p>
          )}
        </div>
      )}
    </div>
  );
};
